import React, { useEffect, useId, useState } from 'react';
import Modal from './Modal';
import { formatApiError } from '../utils/errorUtils';

export interface FamilyNameFormModalProps {
  open: boolean;
  onClose: () => void;
  title: string;
  initialName?: string;
  submitLabel: string;
  onSubmit: (name: string) => Promise<void>;
}

const FamilyNameFormModal: React.FC<FamilyNameFormModalProps> = ({
  open,
  onClose,
  title,
  initialName = '',
  submitLabel,
  onSubmit,
}) => {
  const formId = useId();
  const [name, setName] = useState('');
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (open) {
      setName(initialName);
      setError('');
    }
  }, [open, initialName]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    const trimmed = name.trim();
    if (!trimmed) {
      setError('Introduceți un nume');
      return;
    }
    setSaving(true);
    setError('');
    try {
      await onSubmit(trimmed);
      onClose();
    } catch (err: any) {
      setError(formatApiError(err.response?.data?.detail) || 'Eroare');
    } finally {
      setSaving(false);
    }
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      title={title}
      footer={
        <>
          <button type="button" className="btn btn-secondary" onClick={onClose} disabled={saving}>
            Anulează
          </button>
          <button type="submit" form={formId} className="btn btn-primary" disabled={saving}>
            {saving ? 'Se salvează…' : submitLabel}
          </button>
        </>
      }
    >
      <form id={formId} onSubmit={handleSubmit}>
        {error && <div className="alert alert-error" style={{ marginBottom: 'var(--sp-4)' }}>{error}</div>}
        <div className="form-group">
          <label className="form-label" htmlFor="family-name-input">
            Nume familie
          </label>
          <input
            id="family-name-input"
            className="form-input"
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="ex: Familia Popescu"
            required
            autoFocus
          />
        </div>
      </form>
    </Modal>
  );
};

export default FamilyNameFormModal;
